<template>
<v-container fluid>
    <WareHousePomItemComponent/>
    <WareHousePomTableComponent />
</v-container>
   

</template>

<script>
// @ is an alias to /src
import { serverBus } from "../main";

import WareHousePomItemComponent from "@/components/WareHousePomItemComponent.vue";
import WareHousePomTableComponent from "@/components/WareHousePomTableComponent.vue";

export default {
  name: "ware_house_pom",
  components: {
    WareHousePomItemComponent,
    WareHousePomTableComponent
  },
  mounted() {
    // alert("makarije");
    // serverBus.$off("warehouse_types");

    serverBus.$on("scroll_to_top", () => {
      // alert(idRoom);
      

      // console.log(document.getElementById("Dialog"))
      document.getElementById("Dialog").scrollTop = 0;

    })
  }
};
</script>
           
<style scoped lang='scss'>
</style>
